<script setup lang="ts">
import type { TermRelation } from "~/types/article"

defineProps<{
  note: TermRelation
}>()
</script>

<template>
  <USidenote :note="note" title-class="text-dark-blue-dark">
    <template #content>
      <blockquote
        class="ml-2 border-l-2 border-dark-blue-80 pl-4 text-2xl"
        v-html="note.resource.definition"
      />

      <div class="text-xl" v-html="note.resource.explanation" />
    </template>
  </USidenote>
</template>
